import script from "./CALENDAR_EVENT.vue?vue&type=script&setup=true&lang=ts"
export * from "./CALENDAR_EVENT.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__